import styled from "styled-components";

export const CardSecondaryHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: center;
    gap: 10px;
    h5 {
      font-weight: 400;
      margin: 0;
    }
  }
  .right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;


export const CardSecondary = styled.div`
  background-color: var(--theme-color-secondary);
  border: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border-radius: 1rem;
  text-transform: capitalize;
  overflow: hidden;

  h5 {
    font-weight: 400;
    margin: 0;
  }
`;

export const CardSecondaryContent = styled.div`
  width: 100%;
  display: grid;
  gap: 5px 20px;
  overflow-x: auto;

  ${({ valueCount }) =>
    valueCount < 4
      ? `
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  `
      : `
    grid-template-columns: repeat(6, minmax(0, 1fr));
  `}

  p {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 13px;
    overflow: hidden;
  }

   strong {
      font-weight: bold;
    }
`;